import React from "react";
import SoundLibraryList from "../../components/lists/SoundLibraryList";
import { useTranslation } from "react-i18next";
import styles from "./SoundLibrary.module.css";

const SoundLibrary: React.FC = () => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;
    return (
        <div className={styles.page}>
            <div className={styles.head}>
                <h1>{t("soundLibrary")}</h1>
                <p>{t("soundLibrarySubtitle")}</p>
            </div>
            <SoundLibraryList />
        </div>
    );
};

export default SoundLibrary;
